const GROUP_TYPES = {
  byField: '1',
  byName: '2',
};

export default GROUP_TYPES;
